import "@nextgisweb/jsrealm/with-chunks!@nextgisweb/jsrealm/testentry/driver"
import entrypoint from "@nextgisweb/jsrealm/entrypoint";
import { registry } from "/opt/ngw/package/nextgisweb/nextgisweb/jsrealm/nodepkg/jsrealm/testentry/driver/index.ts";
import * as m0 from "/opt/ngw/package/nextgisweb/nextgisweb/gui/nodepkg/testentry/driver/react.ts"; m0;
export * from "/opt/ngw/package/nextgisweb/nextgisweb/jsrealm/nodepkg/jsrealm/testentry/driver/index.ts";
if (!registry) throw new Error("Registry '@nextgisweb/jsrealm/testentry/driver' is not defined");
registry.seal();